export const SET_AUTH_INIT = 'auth/SET_AUTH_INIT'
export const SET_AUTH_FETCHING = 'auth/SET_AUTH_FETCHING'
export const SET_AUTH_TOKEN = 'auth/SET_AUTH_TOKEN'
export const LOG_OUT = 'auth/LOG_OUT'
